/* eslint-disable */
import * as Types from './types';

export type ManualProductRecommendationsFragment = { __typename?: 'ManualProductRecommendations', title?: string | null, description?: string | null, descriptionLinkUrl?: string | null, descriptionLinkText?: string | null, descriptionLinkOpenLinkInNewTab?: boolean | null, ctaText?: string | null, ctaUrl?: string | null, openLinkInNewTab?: boolean | null, enableBackground?: boolean | null, filters?: string | null, proContent?: boolean | null, ruleContext?: string | null, recommendationsType?: string | null, collection?: { __typename?: 'Collection', title?: string | null, handle?: string | null, id?: string | null } | null };

export declare const ManualProductRecommendationsFragment: import("graphql").DocumentNode;
export const ManualProductRecommendationsFragmentDoc = /*#__PURE__*/ `
    fragment ManualProductRecommendationsFragment on ManualProductRecommendations {
  title
  description
  descriptionLinkUrl
  descriptionLinkText
  descriptionLinkOpenLinkInNewTab
  ctaText
  ctaUrl
  openLinkInNewTab
  enableBackground
  filters
  collection {
    title
    handle
    id
  }
  proContent
  ruleContext
  recommendationsType
}
    `;